module.exports = __webpack_public_path__ + "static/media/SePeru-3.69029c0d.JPG";